import { CboRole } from '@cbo/shared-library';
import { User } from '../../../models/User';
import { SelectedUser } from '../components/PublishReportDialog';

export const checkHasAllCustomReportsViewAccess = (user: User) =>
  user.bslAuth?.roles?.includes(CboRole.ADMIN_LINK_VIEWER) ||
  user.bslAuth?.roles?.includes(CboRole.SUPPORT_LINK_VIEWER) ||
  false;

export const formatSelection = (
  groupId: string,
  optionId: string,
  optionLabel: string,
  userName?: string
): SelectedUser => ({
  groupType: groupId,
  optionId,
  name: optionLabel,
  id: `${groupId}.${optionId}`,
  userName,
});
